import { Component, ViewEncapsulation, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: 'app-adjustmentnote-screen',
    templateUrl: './adjustmentnote.screen.component.html',
    standalone: false
})

export class AdjustmentNoteScreenComponent  {
  @Input() description;
  constructor(
    public activeModal: NgbActiveModal) {
  }
  closePopup() {
    this.activeModal.close('Close click');
  }
}
